import DeleteFailedRecordingModal from "@/components/DeleteFailedRecordingModal";
import { useAppModal } from "@/contexts/AppModal/useAppModal";
import { Recording } from "@/models/recording";
import {
  ButtonSize,
  ButtonVariant,
  Color,
  DeleteIcon,
  HorizontalFlex,
  IconButton,
  IconSize,
  InformationFilledIcon,
  RefreshIcon,
  Space,
  Tooltip,
} from "@enxcs/dap-ui-stratos";
import { lazy, type FC } from "react";

const UploadRecordingModal = lazy(() => import("@/components/UploadRecordingModal"));
import { useTranslation } from "react-i18next";

type FailActionsUploadProps = {
  record: Recording;
};

const FailActionsUpload: FC<FailActionsUploadProps> = ({ record }) => {
  const { t } = useTranslation();

  const { onOpenModal, onCloseModal } = useAppModal();

  const handleDelete = () => {
    onOpenModal(<DeleteFailedRecordingModal recordingId={record.recordingId} />);
  };

  const handleRetry = () => {
    onOpenModal(<UploadRecordingModal onClose={onCloseModal} retryRecording={record} />);
  };

  return (
    <HorizontalFlex $justify="flex-end" $padRight={"36px" as Space} $gap={Space.V4}>
      <Tooltip content={t("failMessage.uploadFailed")}>
        <HorizontalFlex $pad={Space.V8}>
          <InformationFilledIcon size={IconSize.V16} tone={Color.Teal.V30} />
        </HorizontalFlex>
      </Tooltip>

      <IconButton icon={RefreshIcon} title={t("buttons.tryAgain")} size={ButtonSize.S} onClick={handleRetry} />
      <IconButton icon={DeleteIcon} variant={ButtonVariant.GHOST} title={t("buttons.delete")} size={ButtonSize.S} onClick={handleDelete} />
    </HorizontalFlex>
  );
};

export default FailActionsUpload;
